import { Exception } from '@core/exceptions/exception';

export class ActivatedRouteParamNotFoundException extends Exception {
  constructor(message = 'Activated router param not found.') {
    super(message);
  }
}
